import { forwardRef } from 'react'
import { UseFormRegister } from 'react-hook-form'

interface SelectOption {
  valor: string | number
  texto: string
}

interface SelectProps {
  label: string
  name: string
  opcoes: SelectOption[]
  obrigatorio?: boolean
  register: UseFormRegister<any>
  error?: any
  className?: string
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, name, opcoes, obrigatorio, register, error, className = "" }, ref) => {
    const { ref: registerRef, ...registerProps } = register(name)
    
    return (
      <div className={`space-y-1 ${className}`}>
        <label className="block text-sm font-medium text-gray-700">
          {label}
          {obrigatorio && <span className="text-red-500 ml-1">*</span>}
        </label>
        <select
          {...registerProps}
          ref={(e) => {
            registerRef(e)
            if (typeof ref === 'function') {
              ref(e)
            } else if (ref) {
              ref.current = e
            }
          }}
          className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
            error ? 'border-red-500' : 'border-gray-300'
          }`}
        >
          <option value="">Selecione...</option>
          {opcoes.map((opcao) => (
            <option key={opcao.valor} value={opcao.valor}>
              {opcao.texto}
            </option>
          ))}
        </select>
        {error && <p className="text-sm text-red-600">{error.message}</p>}
      </div>
    )
  }
)
